import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { ClinicDetailQuery } from '../../state/clinic-detail/clinic-detail.query';

@Component({
    selector: 'app-result-modal',
    templateUrl: './result-modal.component.html',
    styleUrls: ['./result-modal.component.scss'],
})
export class ResultModalComponent implements OnInit {
    @Input() labelResult: string = '';
    @Input() labelDissmisModal: string = ''; 
    @Input() showCalendarButton: boolean = false;
    @Input() isAppointment: boolean = false;

    clinicName$: Observable<string> = new Observable<string>;

    constructor(
        private modalController: ModalController,
        private clinicDetailQuery: ClinicDetailQuery
    ) {}

    ngOnInit(): void {
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');
    }

    dismissModal(): void {
        this.modalController.dismiss({
            dismissed: true,
        });
    }
}
